import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mojo-candidate-achievements-card',
  templateUrl: './candidate-achievements-card.component.html',
  styleUrls: ['./candidate-achievements-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateAchievementsCardComponent {
  private readonly achievementCharactersLimit = 300;
  @Input() showCard = true;
  @Input()
  set achievements(achievements: string[]) {
    this.allAchievements = achievements;
    this.expandable =
      achievements && achievements.join('').length > this.achievementCharactersLimit;
    this.prepareDisplayedAchievements();
  }

  expanded = false;
  expandable = false;
  allAchievements: string[];
  displayedAchievements: string[];

  track = (index: number, item: string) => item;

  toggleCard(expanded: boolean) {
    this.expanded = expanded;
    this.prepareDisplayedAchievements();
  }

  prepareDisplayedAchievements() {
    if (this.expanded) {
      this.displayedAchievements = this.allAchievements;
    } else {
      this.displayedAchievements = [];
      let currentCharactersCount = 0;
      this.allAchievements.forEach((achievement) => {
        if (currentCharactersCount >= this.achievementCharactersLimit) {
          return;
        }
        if (currentCharactersCount + achievement.length > this.achievementCharactersLimit) {
          this.displayedAchievements.push(
            achievement.substring(0, this.achievementCharactersLimit - currentCharactersCount),
          );
          currentCharactersCount = this.achievementCharactersLimit;
        } else {
          this.displayedAchievements.push(achievement);
          currentCharactersCount += achievement.length;
        }
      });
    }
  }
}
